import React from "react"
import { useGoogleLogin } from '@react-oauth/google'
import axios from "axios"

interface Props {
    csrfToken: string;
    setErrorMessage: (msg: string) => void;
    setLoading: (val: boolean) => void;
    onSuccess: ()=> void;
}

export default function SignUpPartners( {csrfToken, setErrorMessage, setLoading, onSuccess}: Props){
    // Function to handle Google sign in
    const signup = useGoogleLogin({
        scope: [
            "openid",
            "email",
            "profile",
            "https://www.googleapis.com/auth/user.gender.read",
            "https://www.googleapis.com/auth/user.birthday.read",
            "https://www.googleapis.com/auth/user.phonenumbers.read"
        ].join(" "),
        onSuccess: async (tokenResponse) => {
            setLoading(true)
            const accessToken = tokenResponse.access_token;
            // API call to check user authenticity
            await axios.post(`${process.env.REACT_APP_SKILLJA_URL}/google/sign_up/`, { access_token: accessToken }, {
                headers: {
                    "X-CSRFToken": csrfToken,
                    "Content-Type": "application/json",
                    },
                    withCredentials: true,
                })
                .then((res) => {
                    if (res.status === 200) {
                        // signup was unsuccessful
                        if(!res.data?.user_created){
                            // user account already exists
                            if(res.data.user_exists){
                                setErrorMessage("An account with this email already exists")
                                setLoading(false)
                            }
                            else { 
                                // unable to signup with google account information
                                setErrorMessage("An unexpected error occurred with your Google account. Please try again.")
                                setLoading(false)
                            }
                        }
                        // user account was created and signup was successful
                        else {
                            onSuccess()
                            return
                        }
                    }
                })
                .catch((error) => { 
                    // an issue occurred during the sign up process
                    console.error(error)
                    setErrorMessage("Something went wrong. Please try again.")
                    setLoading(false)
                })
        }
    })

    return (
        <div className="bg-main-white w-full mx-auto  my-3 sign-in-partner-btn" onClick={()=>signup()}>
            <img 
                src={require('../../assets/google-logo.png')} 
                className="w-8 ml-5 my-auto rounded-full" 
                role="button"
                aria-label="Sign up with Google"
            />
            <p className="text-main-black my-auto ml-2 mr-9 font-kulim">
                Sign up with Google
            </p>
        </div>
    )
}
